/* TwentySix product card — fits the colours and the sizes on one line (assets/ts-card.css, snippets/product-block.liquid).
   Each card is measured on its own: the sizes always stay whole, and as many colour dots as still fit are shown,
   the rest folded into "+N". If not even one dot fits beside the sizes, the sizes drop to their own line.
   Runs on every card on the page, on cards added later (filters, load more, colour swap, wishlist) and on resize.
   In a row that scrolls sideways (home page sliders, product page rails, the search's new in) the photo swipe
   inside the card stays off, so a swipe scrolls the row and never flips the photos on the way. */
(function () {
  'use strict';
  if (window.TSCard) return;

  var DOT = 13, GAP = 8, COL = 12;
  var ro = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (e) {
      var card = e.target.closest('.pb'), w = Math.round(e.contentRect.width);
      if (card && card.tsW !== w) { card.tsW = w; fit(card); }
    });
  }) : null;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function fit(card) {
    var box = $('.product-block__detail .innerer', card);
    var sw = $('.product-block-options--swatch', card);
    var sz = $('.product-block-options:not(.product-block-options--swatch)', card);
    if (!box) return;
    var items = sw ? $$('.product-block-options__item', sw) : [];
    var more = sw ? $('.pb-more', sw) : null;
    var room = box.clientWidth;
    if (!room) return;

    /* start from everything shown */
    card.classList.remove('pb-sz-below', 'pb-sz-tight');
    items.forEach(function (i) { i.classList.remove('pb-hid'); });
    if (more) more.hidden = true;
    if (!sz || getComputedStyle(sz).display === 'none' || !items.length) return;

    /* the sizes at their natural width (the grid may be squeezing them right now), plus the gap to the colours */
    function natural() {
      sz.style.width = 'max-content'; sz.style.maxWidth = 'none';
      var w = sz.offsetWidth;
      sz.style.width = ''; sz.style.maxWidth = '';
      return w + COL;
    }
    var need = natural();
    var all = items.length * DOT + (items.length - 1) * GAP;
    if (need + all <= room) return;                  /* everything fits as it is */

    /* how many dots fit beside the sizes with a "+N" label */
    if (!more) {
      more = document.createElement('span');
      more.className = 'pb-more';
      $('.product-block-options__inner', sw).appendChild(more);
    }
    more.hidden = false;
    more.textContent = '+' + (items.length - 1);
    var label = more.offsetWidth + GAP;
    var n = Math.floor((room - need - label + GAP) / (DOT + GAP));
    if (n < 1) {                                     /* not even one dot: first try the sizes a touch tighter */
      card.classList.add('pb-sz-tight');
      need = natural();
      if (need + all <= room) { more.hidden = true; return; }
      n = Math.floor((room - need - label + GAP) / (DOT + GAP));
    }
    if (n < 1) {                                     /* still not: sizes go under the colours */
      more.hidden = true;
      card.classList.remove('pb-sz-tight');
      card.classList.add('pb-sz-below');
      return;
    }
    if (n >= items.length) { more.hidden = true; return; }
    more.textContent = '+' + (items.length - n);
    items.forEach(function (i, k) { i.classList.toggle('pb-hid', k >= n); });
  }

  function watch(card) {
    if (card.tsFit) return;
    card.tsFit = true;
    fit(card);
    var box = $('.product-block__detail .innerer', card);
    if (ro && box) ro.observe(box);
  }
  function scan(root) {
    if (root.nodeType === 9) root = root.documentElement;
    if (root.nodeType !== 1) return;
    if (root.classList && root.classList.contains('pb')) watch(root);
    $$('.pb', root).forEach(watch);
  }
  /* every card on the page: the ones not yet watched get their observer, the rest are measured again */
  function all() { $$('.pb').forEach(function (c) { if (c.tsFit) fit(c); else watch(c); }); }

  window.TSCard = { fit: fit, all: all };
  scan(document);
  new MutationObserver(function (muts) {
    muts.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, scan); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(all);
  window.addEventListener('load', all);
  window.addEventListener('pageshow', all);          /* back to the page (also from the browser's page cache) */
  window.addEventListener('orientationchange', function () { setTimeout(all, 150); });

  /* no photo swipe inside a row that scrolls sideways: the theme's card arms its swipe on touchstart
     (main.js, product-block) and reads it on touchmove; disarming it right after, from here, leaves the row's
     own scrolling as the only thing a swipe does. Grids keep the swipe and the dots that show it. */
  function sideways(el) {
    for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      var o = getComputedStyle(p).overflowX;
      if (o === 'auto' || o === 'scroll') return true;
    }
    return false;
  }
  document.addEventListener('touchstart', function (e) {
    var t = e.target;
    if (!window.theme || !t || !t.closest) return;
    var photos = t.closest('.pb .image-cont--with-secondary-image');
    if (photos && sideways(photos)) window.theme.productBlockTouchTracking = false;
  }, { passive: true });
})();
